// ==============================|| THEME CONFIG ||============================== //
// Drawer widths live in ./drawerConfig.js (width / miniWidth).

const themeConfig = {
  fontFamily: `'PT Sans', 'Roboto', sans-serif`,
  borderRadius: 8,
  outlinedFilled: true,
  presetColor: 'default'
};

export default themeConfig;
